export type DictionaryName =
  | 'default'
  | 'direct-assurance'
  | 'franceparebrise'
  | 'matmut'
  | 'pop3p'
  | 'glassdrive'
  | 'autoverbr';
